import { closeCurrentModal } from 'weblite-web-modal-viewer'
import { PopupMenuItem, PopupMenuList } from '$common/popup-menu'
import { CopyIcon } from '$common/icons/copy'
import { copyToClipboard } from '$func/clipboard'
import { t } from '$i18n'

interface Props {
  text: string
  isOpen: boolean
  onDone: () => unknown
}

export function CopyMenu({ text, isOpen, onDone }: Props) {
  return (
    <PopupMenuList open={isOpen}>
      <PopupMenuItem
        text={t('menu.common.copy')}
        onClick={() => {
          copyToClipboard(text)
          closeCurrentModal()
          onDone()
        }}
      >
        <CopyIcon />
      </PopupMenuItem>
    </PopupMenuList>
  )
}
